import React from 'react';
import { useState } from "react";
import { login } from '../services/reactapis';
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import CustomCard from "../components/CustomCard";
import Logingirl from '../assets/Logingirl1.webp';
import Loginlogo from '../assets/loginlogo.jpg';
import "../CssPage/Login.css";
import CustomButton from "../components/CustomButton";
import axios from 'axios';
import { ApiUrl } from '../Constants/Weburl'
import { useNavigate } from "react-router-dom";
import '../App.css'
import logo from '../assets/goshortzzlogo.webp';



export default function Login() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");


  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      return alert("Please fill all fields");
    }

    try {
      const response = await login(email, password);

      console.log("Login response:", response);

      if (response?.status === 200) {
        const { token, user } = response.data;

        localStorage.setItem("adminToken", token);
        localStorage.setItem("adminUser", JSON.stringify(user));

        navigate("/dashboard");
      } else {
        alert(response?.data?.message || "Login failed");
      }
    } catch (error) {
      console.log("Login error:", error);
      console.log("API error:", error?.response?.data);

      alert(error?.response?.data?.message || "Login failed");
    }
  };


  return (
    <Container fluid className="login-page">
      <Row className="justify-content-center align-items-center login-row">
        <Col xs={12} lg={10} className="login-wrapper">


          <div className="login-illustration-panel">
            <CustomCard
              image={Logingirl}
              className="illustration-card"
              imgClassName="illustration-img"
            />
          </div>



          <Card className="login-card">
            <Card.Body>

              <div className="loginlogo">
                <img
                  src={logo}
                  alt="Logo"
                />
              </div>
              {/* Header */}
              <div className="login-header">

                <h4 className="login-label">
                  Log In
                  <span className="login-underline"></span>
                </h4>

              </div>

              <h1 className="login-title">Welcome Back</h1>
              <p className="login-subtitle">
                Thank you for getting back, please login to your account
                by filling these from:
              </p>

              <Form onSubmit={handleLogin}>
                <Form.Group className="mb-3 input-group-custom">
                  <Form.Label className="input-label">Email Address</Form.Label>
                  <Form.Control
                    // type="text"
                    // value="tester"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="login-input"
                  />
                </Form.Group>

                {/* Password */}

                <Form.Group className="mb-3 input-group-custom">
                  <Form.Label className="input-label">Password</Form.Label>
                  <Form.Control
                    // type={show ? "text" : "password"}
                    // value="123456"
                    type={show ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="login-input"
                  />
                </Form.Group>
                {/* <span
                    className="eye"
                    onClick={() => setShow(!show)}
                  >
                    👁
                  </span> */}

                <div className="login-options">
                  <a href="/forget-password" className="forgot-link">
                    Forgot password
                  </a>
                </div>




                {/* Login Button */}

                <div className="login-buttons">
                  <CustomButton type="submit" className="btn-login">
                    Login
                  </CustomButton>

                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container >

  );
}
